module.exports = __webpack_public_path__ + "h5/img/noCoupon.d42c1f51.png";